export default "__VITE_ASSET__DDLWkS5w__"